export const getPerformingCount = (count: number): string => {
  switch (true) {
    case count >= 10:
      return `수행 ${count}건`;
    case count >= 1 && count < 10:
      return '수행 10건 미만';
    default:
      return '';
  }
};
